// extracted by mini-css-extract-plugin
module.exports = {"emptyTitle":"AllPokemons_emptyTitle__1wLef","imageContainer":"AllPokemons_imageContainer__1lNc8","deleteButton":"AllPokemons_deleteButton__2DaYs"};